import { styled } from "@mui/material/styles";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { IconButton, IconButtonProps } from "@mui/material";

interface StyledFiltersButtonProps extends IconButtonProps {
  isFiltered?: boolean;
}

export const StyledFiltersButton = styled(
  ({ isFiltered: _isFiltered, ...props }: StyledFiltersButtonProps) => (
    <IconButton {...props}>
      <TuneRoundedIcon fontSize="medium" />
    </IconButton>
  ),
  {
    shouldForwardProp: (prop) => prop !== "isFiltered",
  },
)(
  ({
    theme,
    isFiltered,
  }: {
    theme: import("@mui/material/styles").Theme;
    isFiltered?: boolean;
  }) => ({
    marginTop: 1,
    marginRight: 0,
    marginLeft: "8px",
    fontSize: 32,
    flexShrink: 0,
    cursor: "pointer",
    color: !!isFiltered
      ? theme.palette.darkGray.main
      : theme.palette.redAlert.main,
    width: "40px",
    height: "40px",
  }),
);
